import Cookie from "js-cookie";
import { ApiRoutes } from "consts/enpoints/api";
import type { NewPasswordCredentials, TwoFactorVerify, UserCredentials } from "features/auth/types";
import { getUser as getUserApi } from "features/users/api";
import { fetchApi } from "infrastructure/api";
import AuthException from "./exceptions";
import { getUserId } from "./helpers";

export const getUser = () => {
  const userId = getUserId();

  if (!userId) {
    return Promise.reject(
      new AuthException(
        `User ID is not provided`,
        {}
      )
    );
  }

  return getUserApi(userId);
};

export const login = (body: UserCredentials) =>
  fetchApi(ApiRoutes.PostLogin, {
    method: "post",
    body: {
      ...body,
      trustToken: Cookie.get('trustToken')
    },
  });

export const logout = () =>
  fetchApi(ApiRoutes.PostLogout, {
    method: 'post'
  });

export const verify = (body: TwoFactorVerify) =>
  fetchApi(ApiRoutes.PostVerify2FA, {
    method: 'post',
    body
  });

export const resend2FACode = () =>
  fetchApi(ApiRoutes.PostResend2FACode, {
    method: 'post'
  });

export const recover = (body: Pick<UserCredentials, 'email'>) =>
  fetchApi(ApiRoutes.PostRecover, {
    method: 'post',
    body
  });

export const newPassword = (body: NewPasswordCredentials) =>
  fetchApi(ApiRoutes.PostNewPassword, {
    method: 'post',
    body
  });
